import { computed, ref, shallowReadonly } from '@vue/composition-api';
// import { Message } from '../dataType';
// import { useConfig } from './useConfig';
import Vue, { AsyncComponent, Component } from 'vue';
const Drawer = () => import('../components/Drawer.vue');

export const showDrawer = ref(false);
let instance: Vue| undefined;

type DrawerComponent = Component | AsyncComponent;
export const useRender = () => {
  const openPreviewDrawer = ({ url, name, size }: { url: string, name: string, size?: number }): void => {
    if (!instance) {
      // const { i18n } = useConfig();
      const div = document.createElement('div');
      div.className = 'zk-file-preview-root';
      document.body.appendChild(div);
      instance = new Vue({
        // i18n,
        data: () => {
          return {
            visible: false
          };
        },
        methods: {
          show() {
            this.visible = true;
            showDrawer.value = true;
          },
          hide() {
            this.visible = false;
            showDrawer.value = false;
          }
        },
        render(h) {
          // Wrap in a persistent root div so $mount replaces the placeholder
          // with another element that keeps the .zk-file-preview-root class.
          // This ensures closest('.zk-file-preview-root') always resolves.
          return h('div', { class: 'zk-file-preview-root' }, [
            this.visible ? h(Drawer, { props: {
              url,
              name,
              size
            } }) : h()
          ]);
        }
      });
      instance.$mount(div);
    }
    (instance as any).show();
  };

  const closePreviewDrawer = (destroy: boolean): void => {
    if (!instance) {
      return;
    }
    (instance as any).hide();
    if (destroy) {
      const { $el } = instance;
      instance.$destroy();
      $el.remove();
      instance = void 0;
    }
  };

  return {
    openPreviewDrawer,
    closePreviewDrawer,
    showDrawer,
    isRender: shallowReadonly(showDrawer)
  };
};
